import http from '../api/httpRequest.js'
import { RTC_STATE } from "../api/enums.js"
import router from '../router'

export default {

	state: {
		userInfo: {

		},
		rtcInfo: {
			friend: {},  // 好友信息
			mode: "video", // 模式 video:视频 voice:语音
			state: RTC_STATE.FREE // FREE:空闲  WAIT_CALL:呼叫方等待 WAIT_ACCEPT: 被呼叫方等待接听  CHATING:聊天中 
		},
		menu: [],
		routers: [],
		roles:[],
		permissions: [],
		packageInfo: {},
		PublicKey:''
	},

	mutations: {
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo
		},
		setRtcInfo(state, rtcInfo) {
			state.rtcInfo = rtcInfo;
		},
		setRtcState(state, rtcState) {
			state.rtcInfo.state = rtcState;
		},
		setMenu(state, menu) {
			state.menu = menu;
		},
		setRouter(state, routers) {
			state.routers = routers;
		},
		setPermissions(state, permissions) {
			state.permissions = permissions;
		},
		setRoles(state, roles){
			state.roles = roles;
		},
		setPackageInfo(state, packageInfo){
			state.packageInfo = packageInfo;
		},
		clear(state) {
			state.userInfo = {};
			state.rtcInfo = {
				friend: {},
				mode: "video",
				state: RTC_STATE.FREE
			};
		},
		setPublicKey(state, PublicKey){
			console.log("PublicKey=", PublicKey);
			state.PublicKey = PublicKey;
		},
	},
	actions: {
		loadUser(context) {
			return new Promise((resolve, reject) => {
				http({
					url: '/user/self',
					method: 'GET'
				}).then((userInfo) => {
					// const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
					// link.type = 'image/png';
					// link.rel = 'icon';
					// link.href = userInfo.headImageThumb;
					// document.head.appendChild(link);
					context.commit("setUserInfo", userInfo);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		},
		loadRouters(context){
			return new Promise((resolve, reject) => {
				http({
					url: '/getRouters',
					method: 'GET'
				}).then((res) => {
					// 动态加载路由
					const home = router.options.routes.find(r => r.name === "Home");
					const setting = home.children.find(r => r.name === "Setting");
					const arrRouter = res.map((item) => { 
						return item.children.map((itm)=>{
							const subPath = itm.path.replace('/home/setting/', '');
							return{
								path: subPath,
								name: subPath,
								meta: {
									title: itm.meta.title,
								},
          					  	component: () => import(`../components/setting/${subPath}.vue`),
							}
						})
					}).flat()
					context.commit("setMenu", res);
					context.commit("setRouter", arrRouter);
					arrRouter.forEach(route => {
						const alreadyAdded = setting.children.some(r => r.name === route.name);
						if (!alreadyAdded) {
							router.addRoute("Setting", route);
							setting.children.push(route);
						}
					});
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		},
		loadUserInfo(context) { 
			return new Promise((resolve, reject) => {
				http({
					url: '/getInfo',
					method: 'GET'
				}).then((res) => {
					context.commit("setPermissions",res.permissions)
					context.commit("setRoles",res.roles)
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		},
		loadPackageInfo(context) { 
			return new Promise((resolve, reject) => {
				http({
					url: '/customer/userPackageInfo',
					method: 'POST'
				}).then((res) => {
					context.commit("setPackageInfo",res)
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		},
	}
}